const STRINGS = {
    ACTION_SUCCEED: 'הפעולה הצליחה',
    ACTION_FAILED: 'הפעולה נכשלה',

    MY_STRATEGY: 'רשימת האסטרטגיות שלי',


    EDIT_GROUP_SCREEN_TITLE: 'עריכת קבוצה ופרופילי טעינה',

    MY_PROFILES_CHARGER_TITLE: 'הפרופילים של המטענים שלי',
    MY_PROFILES_GROUP_TITLE: 'הפרופילים של הקבוצות שלי',

    ADD_PROFILE: 'הוספת פרופיל',
    ADD_CHARGINGֹֹ_STRATEGY: 'הוספת אסטרטגיה',


    MY_GROUPS_UNATTACHED_CHARGERS_TITLE: 'לא משוייכים',
    EDIT_GROUP: 'עריכת קבוצה',

    ADD_CHARGER: 'הוספת מטען',

    // MY_CHARGERS_CARDS_DRIVERS: 'המטענים, הכרטיסים והנהגים שלי',

    MY_CHARGERS_GROUPS: 'קבוצות המטענים שלי',

    VENDOR: 'יצרן',
    MODEL: 'מודל',

    NICKNAME: 'כינוי',

    HOURS: 'שעות',
    HOUR: 'שעה',
    MINUTES: 'דקות',


    PERMISSIONS_TITLE: 'עריכת כרטיסים ושיוכים',

    EDIT_DRIVER: 'עריכת נהג',


    DRIVER_NAME: 'שם נהג',
    ADD_DRIVER: 'הוספת נהג',
    EMAIL: 'דואר אלקטרוני',


    PERMISSIONS: 'שיוכים',

    PROFILE_TYPE_DAILY: 'יום-יומי',
    PROFILE_TYPE_WEEKLY: 'שבועי',
    PROFILE_TYPE_TODAY: 'היום',

    CARD_ADDED: 'הכרטיס נוסף',
    CARD_ERROR_DUPLICATED: 'המספר כרטיס כבר קיים במערכת',


    GENERAL_ERROR: 'הפעולה נכשלה',

    PERSONAL_DETAILS: 'פרטים אישיים',

   



    NULL_USER: "00000000-0000-0000-0000-000000000000",





    // Charging Strategy
    ADD_STATEGY_TITLE: 'הוספת אסטרטגיה',
    UPDATE_STATEGY_TITLE: 'עריכת אסטרטגיה',



    // Changed to multypled languages
    MY_CHARGERS_CARDS_DRIVERS: 'מטענים/ כרטיסים/ נהגים',
    MY_CHARGERS: 'מטענים',

    MENU_PERSONAL: 'פרטים אישיים',
    MENU_GROUPS: 'קבוצות מטענים',
    MENU_CHARGERS_CARDS_DRIVERS: 'מטענים/כרטיסים/נהגים',
    MENU_CHARGERS: 'מטענים',
    MENU_PAYMENTS: 'היסטורית טעינות',
    MENU_CREDIT_CARD_DETAILS: 'אמצעי תשלום',
    MENU_CHARGINGֹֹ_STRATEGY: 'אסטרטגיית טעינה',
    MENU_CREDIT_CARD_DETAILS_UPDATE: 'אמצעי תשלום',
    QR_TITLE: "סרוק את הברקוד המופיע על המטען",

    PAYMENTS: 'חשבוניות',
    DETAILS: 'הצג פעולות',
    GRAPH: 'הצג גרף',

    BILLS_NOT_INCLUDE_TAX: 'ללא מע"מ',
    BILLS_INCLUDE_TAX: 'סה"כ חייב במע"מ',
    BILLS_TOTAL: 'סה"כ לתשלום',
    BILLS_TAX: 'מע"מ',

    CHARGER_FORM_ADD_CHARGER: 'הוספת מטען',
    ACTIVATION_NUMBER: 'מספר הפעלה',
    SERIAL_NUMBER: 'מספר מטען',

    CHARGERING_TYPE_LABEL: 'סוג טעינה',
    CHARGERING_TYPE_REGULAR: 'רגילה',
    CHARGERING_TYPE_AUTOMATIC: 'אוטומטית',
    CHARGERING_TYPE_SMART: 'חכמה',
    EDIT_CHARGER_SCREEN_TITLE_OPU_PERMISSIONS: 'עריכת מטען ופרופילים',
    EDIT_CHARGER_SCREEN_TITLE_USER_PERMISSIONS: 'עריכת מטען',
    POPUP_PROCEED_TO_PROFILES_WITHOUT_SAVEING_MSG: 'הזרם המכסימלי השתנה אבל לא נשמר, האם להמשיך למסך הפרופילים ?',
    POPUP_PROCEED_TO_PROFILES_WITHOUT_SAVEING_TITLE: 'המשך למסך הפרופילים',

    EDIT_CHARGER: 'עריכת מטען',
    PROFILES: 'פרופילי טעינה',

    TODAY: 'היום',
    DAILY: 'יום-יומי',
    WEEKLY: 'שבועי',
    PROFILES_LIMIT_ACTIVE_ERROR: 'לא ניתן להוסיף או להפעיל פרופיל נוסף',

    ADD_CARD: 'הוספת כרטיס',
    EDIT_CARD: 'עריכת כרטיס',
    TAG_ID: 'מספר כרטיס',
    TAG_NAME: 'שם כרטיס',
    EDIT_CARD_AND_PERMISSIONS: 'עריכת כרטיס ',

}

export default STRINGS;